<template>
    <div class="skeleton-photo skeleton-el">
        <div class="block1 block"></div>
        <div class="block2 block"></div>
        <div class="block3 block"></div>
        <div class="block4">
            <div class="block"></div>
            <div class="block"></div>
        </div>
        <div class="block5 block"></div>
        <div class="block6">
            <div>
                <div class="block"></div>
                <div class="block"></div>
            </div>
            <div class="block"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonPhoto',
};
</script>
<style lang="scss" scoped>
.skeleton-photo {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    padding: 118px 30px 0;
    background: #fff;
    .block {
        background: #F0F0F0;
    }

    .block1, .block3 {
        width: 136px;
        height: 40px;
        border-radius: 20px;
    }
    .block2 {
        height: 377px;
        margin: 25px 0 37px;
    }
    .block4 {
        @include SpaceBetween();
        margin-top: 28px;
        div {
            width: 332px;
            height: 48px;
            border-radius: 24px;
        }
    }
    .block5 {
        height: 180px;
        margin-top: 30px;
    }
    .block7 {
        @include SpaceBetween();
        align-items: center;
        margin-top: 24px;
        div:first-child {
            width: 136px;
            height: 36px;
            border-radius: 18px;
        }
        div:last-child {
            width: 140px;
            height: 56px;
            border-radius: 28px;
        }
    }
    .block8 {
        @include SpaceBetween();
        margin-top: 20px;
        li {
            width: 156px;
            height: 156px;
        }
    }
    .block6 {
        width: 100vw;
        height: 130px;
        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        @include SpaceBetween();
        align-items: center;
        padding: 0 30px 0 40px;
        & > div {
            &:first-child {
                @include SpaceBetween();
                div {
                    width: 100px;
                    height: 36px;
                    border-radius: 18px;
                    margin-right: 29px;
                }
            }
            &:last-child {
                width: 274px;
                height: 76px;
                border-radius: 38px;
            }
        }
    }
}
</style>
